module.exports = __webpack_public_path__ + "img/tech_12.700f3c92.jpg";